import AppRestService from './app-rest.service';


/**
 * Service Endpoint Implementation
 */
export default class PublishService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'publish';
    this.routePath = 'system/publish';
    this.idParamName = 'id';
    this.modelClass = null;
    this.authEnabled = true;
  }

  async publishPreview(publishData, opts = null) {
    let path = [this.routePath, 'preview'];
    opts = this._getDefaultRequestOpts(opts);
    let postParams = { publishData };
    let res = await this.request.post(path, postParams, null, opts);
    res = this._populateResponseModel(res);
    return res;
  }

  async publishFinal(publishData, opts = null) {
    let path = [this.routePath, 'final'];
    opts = this._getDefaultRequestOpts(opts);
    let postParams = { publishData };
    let res = await this.request.post(path, postParams, null, opts);
    res = this._populateResponseModel(res);
    return res;
  }

}

